import {useState,type ReactNode} from 'react';
import {useWorkspace} from '../App';

const openStates=new Map<string,boolean>();
const pageStates=new Map<string,number>();
export function clearCsvViewState(){openStates.clear();pageStates.clear();}
export function useCsvPage(recordKey:string){const {actorId}=useWorkspace(),key=actorId+':'+recordKey;const [page,setPage]=useState(pageStates.get(key)||1);return [page,(value:number)=>{pageStates.set(key,value);setPage(value);}] as const;}
export function CsvDisclosure({recordKey,defaultOpen=false,className,children}:{recordKey:string;defaultOpen?:boolean;className?:string;children:ReactNode}){
 const {actorId}=useWorkspace(),key=actorId+':'+recordKey,[open,setOpen]=useState(openStates.get(key)??defaultOpen);
 return <details className={className} open={open} onToggle={e=>{const value=e.currentTarget.open;openStates.set(key,value);if(value!==open)setOpen(value);}}>{children}</details>;
}
